import { message } from 'antd';
import routes from 'global/Constants/routes';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect as RedirectTemp, Route as RouteTemp } from 'react-router-dom';
import { RootState } from 'redux/store';

const Redirect = RedirectTemp as any;
const Route = RouteTemp as any;

interface IProtectedRoute {
  path: string;
  component: React.LazyExoticComponent<React.FC>;
  isPrivate: boolean;
  accessRole: boolean;
}

const ProtectedRoute: FC<IProtectedRoute> = ({ isPrivate, accessRole, path, component: Component }) => {
  const { isLoggedIn } = useSelector((state: RootState) => state.user);

  if (!isPrivate) return <Route path={path} render={() => <Component />} />;

  return (
    <Route
      path={path}
      render={() => {
        if (!isLoggedIn) return <Redirect to={routes.login.path} />;
        if (isLoggedIn && !accessRole) {
          if (!isLoggedIn) return <Redirect to={routes.login.path} />;
          message.warning('شما دسترسی به این صفحه ندارید.');
          return <Redirect to={routes.dashboardHome.path} />;
        }
        return <Component />;
      }}
    />
  );
};

export default ProtectedRoute;
